import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import { useDispatch, useSelector } from 'react-redux';
import { GetBlocks } from '../../store/blocks/actions';
import { GetMainBlocks } from '../../store/main/actions';
import { AppStore } from '../../store/applicationState';
import {
  CheckVideoVisitors,
  DeleteVideoVisitors,
  GetVideoById,
  TypeCreateVideoR,
  UpdateVideo,
} from '../../store/video/actions';
import { VideoForm } from '../../components/VideoForm';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { ConfigurationsActions } from '../../store/configurations/actions';
import { IDocumentVisitor } from '../../store/consultations/types';
import { AlertModal } from '../../components/modals/AlertModal';

export const EditVideo: React.FC = () => {
  const { Video } = useSelector((store: AppStore) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [visitors, setVisitors] = React.useState<IDocumentVisitor[] | null>();

  React.useEffect(() => {
    if (id) {
      dispatch(GetVideoById.request({ id: Number(id) }));
      dispatch(
        CheckVideoVisitors.request({
          id: +id,
        })
      );
    }
  }, [dispatch, id]);

  React.useEffect(() => {
    if (Video.current) {
      dispatch(ConfigurationsActions.setSiteId(Video.current.site_id));
    }
  }, [dispatch, Video]);

  React.useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      dispatch(DeleteVideoVisitors.request({ id: !isNaN(Number(id)) ? Number(id) : 0 }));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      dispatch(DeleteVideoVisitors.request({ id: !isNaN(Number(id)) ? Number(id) : 0 }));
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigate, dispatch, id]);

  React.useEffect(() => {
    setVisitors(Video.visitors);
  }, [Video]);

  const handleUpdate = (
    data: TypeCreateVideoR['data'],
    callBack: (err?: { name: string; message: string }) => void
  ) => {
    if (!Video.current) return null;
    dispatch(
      CheckVideoVisitors.request({
        id: Video.current.id,
      })
    );
    dispatch(
      UpdateVideo.request({
        data,
        id: Video.current.id,
        callBack: (success, dta) => {
          if (!success && dta) {
            if (dta.status === 409) {
              callBack({ name: 'title', message: 'Такий заголовок вже використовується' });
            } else if (dta.status === 410) {
              callBack({ name: 'error', message: 'Публікацію видалено' });
            } else {
              callBack({ name: 'error', message: 'Сталася помилка' });
            }
          } else {
            callBack();
          }
          if (success && Video.current?.is_public === 1 && data.isPublic === 0) {
            dispatch(GetBlocks.request({ id: Video.current.site_id }));
            dispatch(GetMainBlocks.request({ id: Video.current.site_id }));
          }
        },
      })
    );
  };

  if (!Video.current)
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <CircularProgress color='secondary' />
      </Box>
    );

  return (
    <>
      <AlertModal visitors={visitors} />
      <VideoForm
        type='edit'
        data={Video.current}
        handleSubmit={handleUpdate}
        handleCancel={() => {
          navigate(ROUTES.routeChange('list'));
          dispatch(DeleteVideoVisitors.request({ id: !isNaN(Number(id)) ? Number(id) : 0 }));
        }}
      />
    </>
  );
};
